export default {
    zh: {
        BCManage: 'BC管理',
        BC: 'BC',
        BCNumber: 'BC Number',
        SSRNumber: 'SSR Number',
        BCDetail: 'BC Detail',
        BCInfo: 'BC Particular',
        approvalLog: 'Log',
        RFPNumber: 'RFP Number',
        isApproval: 'Submit to the CFO',
        SubmitBy: 'Select Category Leader',
        to: 'to',
        PleaseUpload: 'Please Upload Attachment First',
        cqsApprover: 'Select CQS',
        projectName: 'Project Name',
        businessTemplate: 'BUSINESS CASE Template',
        businessPDF: 'BUSINESS CASE',
        createBy: 'Creator',
        Category1: 'Category1',
        Category2: 'Category2',
        createDate: 'Create Date',
        selDate: 'Select Date',
        status: 'Status',
        search: 'Search',
        reset: 'Reset',
        newBuilt: 'New',
        saveDraft: 'Save',
        submit: 'Submit',
        audit: 'Audit',
        close: 'Close',
        serialNo: 'BC Number',
        supplier: 'Supplier',
        file: 'File',
        sel: 'Select Please',
        yes: 'Yes',
        no: 'No',
        selectFile: 'Upload(PDF)',
        OperationTime: 'Update Time',
        OperatorName: 'Update by',
        PedagogicalOperation: 'Update Log',
        opinion: 'Suggestion',
        reviewer: 'Reviewer',
        reviewTime: 'Check Time',
        reviewOperationWindow: 'Reviewer Update Window',
        approvalWindow: 'Approval Window',
        pass: 'Approve',
        have: 'Comment',
        RevisionComments: 'Comment',
        auditor: 'Approver',
        approvalTime: 'Check Date',
        approvalResults: 'Result',
        noPass: 'Disapprove',
        cancel: 'Cancel',
        confirm: 'Confirm',
        suppliercodeOrInvitationCode: 'Supplier Code',
        supplierAbbreviation: 'Supplier Name For Short',
        SupplierName: 'Supplier Name',
        FactoryName: 'Facility Name',
        select: 'Select',
        pleaseChooseToWithdraw: 'Please Select A BC To Withdraw!',
        checkWithdraw: 'Drafts and approved and back documents cannot be withdrawn',
        sureWithdraw: 'Would you like to withdraw the selected record？',
        withdrawOnly: 'Withdraw one at a time'
    },
    en: {
        BCManage: 'BCManage',
        BC: 'BC',
        BCNumber: 'BCNumber',
        SSRNumber: 'SSRNumber',
        BCDetail: 'BCDetail',
        BCInfo: 'BCInfo',
        RFPNumber: 'RFPNumber',
        isApproval: 'is CFO for approval',
        SubmitBy: 'SubmitBy',
        PleaseUpload: 'Please upload the attachment first',
        pleaseChooseToWithdraw: 'Please Select A BC To Withdraw!',
        checkWithdraw: 'Drafts and approved and back documents cannot be withdrawn',
        sureWithdraw: 'Would you like to withdraw the selected record？',
        withdrawOnly: 'Withdraw one at a time'
    }
}